import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_SM_MECHANIC_TASK_TABLE = 'FETCH_SM_MECHANIC_TASK_TABLE'
export const RECEIVE_SM_MECHANIC_TASK_TABLE = 'RECEIVE_SM_MECHANIC_TASK_TABLE'
export const FAILED_SM_MECHANIC_TASK_TABLE = 'FAILED_SM_MECHANIC_TASK_TABLE'

export const FETCH_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE = 'FETCH_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE'
export const RECEIVE_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE = 'RECEIVE_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE'
export const FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE = 'FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE'

export const FETCH_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE = 'FETCH_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE'
export const RECEIVE_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE = 'RECEIVE_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE'
export const FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE = 'FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE'

export function fetchSmMechanicTask(_idSM){

    var _data = {
        id_scheduled_maintenance: _idSM
    }

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SM_MECHANIC_TASK_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SM_MECHANIC_TASK_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: _data
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_SM_MECHANIC_TASK_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SM_MECHANIC_TASK_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SM_MECHANIC_TASK_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchSmMechanicTaskWithId(_idTask){
    var _data = {
        id: _idTask
    }

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SM_MECHANIC_TASK_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SM_MECHANIC_TASK_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: _data
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_SM_MECHANIC_TASK_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SM_MECHANIC_TASK_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SM_MECHANIC_TASK_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SM_MECHANIC_TASK_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}


export function fetchScheduledMaintenanceTaskDetail(id_scheduled_maintenance_mechanic_task){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SCHEDULED_MAINTENANCE_TASK_DETAIL_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_scheduled_maintenance_mechanic_task: id_scheduled_maintenance_mechanic_task
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TASK_DETAIL_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchScheduledMaintenanceTaskProof(id_scheduled_maintenance_mechanic_task){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SCHEDULED_MAINTENANCE_TASK_PROOF,
            headers: {
                Authorization: auth
            },
            data:{
                id_scheduled_maintenance_mechanic_task: id_scheduled_maintenance_mechanic_task
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TASK_PROOF_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}
